export enum UserStatus {
  Active = 'Aktiv',
  InProgress = 'In Bearbeitung',
  Locked = 'Gesperrt'
}
